/**
 * @author chazzhou
 */
import Icon from './icon';

export default Icon;
